import { useState, useEffect } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios"; // Import axios
import Loader from "./Loader";
import AnimateedBackground from "./AnimatedBackground.js";
import { uwinAPI } from "../../../services/uwin.api";
import { rchAPI } from "../../../services/rch.api";
import { rbskAPI } from "../../../services/rbsk.api";
import Footer from "../../../components/Footer.js";
import Parichay from "../../auth/Parichay.js";
import CaptchaBox from "../../auth/CaptchaBox.js";
import ProgramSelect from "../../auth/ProgramSelect.js";
import { programLogos } from "../../../AppConstant/programLogos.js";
import { getActivePrograms } from "../../../services/activePrograms.service.js";
import { useCommon } from "../../../context/CommonContext";
import { encryptData, getUserRole } from "../../../helpers/common-helper";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { sickleAPI } from "../../../services/sickle.api";
import { eopdAPI } from "../../../services/e-opd.api";

export const Login = () => {
	const navigate = useNavigate();
	const [selectedProgram, setSelectedProgram] = useState("");
	const [activePrograms, setActivePrograms] = useState(null);
	const [isPageLoading, setIsPageLoading] = useState(false);
	const [isReferralLocked, setIsReferralLocked] = useState(false);

	// Login form states
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [captcha, setCaptcha] = useState("");
	const [mathCaptcha, setMathCaptcha] = useState({ question: "", answer: 0 });
	const [mobileNumber, setMobileNumber] = useState("");
	const [sickleOtp, setSickleOtp] = useState(new Array(6).fill(""));
	const [SickleOtpText, setSickleOtpText] = useState("");
	const [uwinOtp, setUwinOtp] = useState(new Array(6).fill(""));
	const [UwinOtpText, setUwinOtpText] = useState("");
	const [ShowSendOtp, setShowSendOtp] = useState(false);
	const [resendTimer, setResendTimer] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [uwinTxnId, setUwinTxnId] = useState("");

	const { setNcdUser } = useCommon();

	////////////////////////////////////////////

	const [showReplaceModal, setShowReplaceModal] = useState(false);
	const [replaceMappingData, setReplaceMappingData] = useState(null);
	const [passwordForm, setPasswordForm] = useState(false); // false = hidden, true = visible
	useEffect(() => {
		const loadPrograms = async () => {
			setIsPageLoading(true);

			const res = await getActivePrograms();

			let loadedPrograms = null;
			if (res.success) {

				// res.data = res.data.filter(
				// 	item => item.program_name === "Nikshay"
				// );

				const programs = (res.data || []).filter(
					(program) => program.onlymobile != 1
				);

				setActivePrograms(programs);

				loadedPrograms = programs;
			} else {
				toast.error(res.message, {
					className: "custom-toast-error",
				});
			}

			const params = new URLSearchParams(window.location.search);
			const referralCode = params.get("referralCode");
			if (referralCode) {
				try {
					const refRes = await axios.post("/nodeapi/aggregator/get-program-by-referral", {
						referral_code: referralCode,
					});

					if (refRes?.data && refRes?.data?.status === 1 && refRes?.data?.data) {
						const targetProgramName = refRes?.data?.data?.program_name;
						const matched = loadedPrograms?.find(
							(p) => p?.program_name && p?.program_name.toLowerCase() === targetProgramName.toLowerCase()
						);
						if (matched) {
							setSelectedProgram(matched?.program_name);
							setIsReferralLocked(true);
						} else {
							toast.error("Referral program is not active.", {
								className: "custom-toast-error",
							});
						}
					} else {
						toast.error(refRes?.data?.message || "Invalid referral code.", {
							className: "custom-toast-error",
						});
					}
				} catch (error) {
					toast.error("Failed to resolve referral code.", {
						className: "custom-toast-error",
					});
				} finally {
					navigate("/login", { replace: true });
				}
			}

			setIsPageLoading(false);
		};
		const token =
			localStorage.getItem("SKT_token") ||
			localStorage.getItem("NCD_token") ||
			localStorage.getItem("sickle_token") ||
			localStorage.getItem("PMNDP_token") ||
			localStorage.getItem("JANANI_token") ||
			localStorage.getItem("RBSK_token") ||
			localStorage.getItem("e-OPD_token") ||
			localStorage.getItem("NIKSHAY_valid_user");
		if (token) {
			navigate("/dashboard");
		}
		loadPrograms();
	}, [navigate]);

	useEffect(() => {
		if (
			selectedProgram === "NCD" ||
			selectedProgram === "SASHAKT" ||
			selectedProgram === "PMNDP" ||
			selectedProgram === "Nikshay" ||
			selectedProgram === "UWIN" ||
			selectedProgram === "JANANI" ||
			selectedProgram === "RBSK" ||
			selectedProgram === "e-OPD"
		) {
			generateMathCaptcha();
		}
	}, [selectedProgram]);

	useEffect(() => {
		if (resendTimer > 0) {
			const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
			return () => clearTimeout(timer);
		}
	}, [resendTimer]);

	const handleProgramChange = (event) => {
		setSelectedProgram(event.target.value);
		// Reset form fields when program changes
		setEmail("");
		setPassword("");
		setCaptcha("");
		setMobileNumber("");
		setSickleOtp(new Array(6).fill(""));
		setSickleOtpText("");
		setShowSendOtp(false);
	};

	// Generate math captcha
	const sendCaptcha = async (mobile) => {
		try {
			const response = await axios.post("/nodeapi/scd/sickle-send-captcha", {
				mobileNumber: mobile,
			});
			return response.data;
		} catch (error) {
			return error.response?.data || { success: false, message: "Server not responding" };
		}
	};



	const loginNCD = async () => {
		try {
			setIsLoading(true);

			const encryptedEmail = encryptData(email);
			const encryptedPassword = encryptData(password);

			const response = await axios.post(
				"/nodeapi/ncd/login",
				{
					email: encryptedEmail,
					password: encryptedPassword,
					captcha,
				},
				{
					headers: {
						"x-encrypted": "true",
					},
				},
			);

			if (response.status === 200) {
				const data = response.data.data;

				localStorage.setItem("NCD_token", data.access_token);
				localStorage.setItem("NCD_refresh_token", data.refresh_token);

				const userdetail = {
					firstname: data.username,
					rolename: getUserRole(data.username),
					facilityName: data.facilityName,
					facilitydetail: `${data.facilityType}, ${data.facilityName}`,
					username: data.username,
					ncdusername: data.username,
					loginuser: data.user,
					stateCode: data.stateCode,
					facility: data.facility,
					facilityTypeId: data.facilityTypeId,
					facilityType: data.facilityType,
				};

				// ✅ 1. Update Context state
				setNcdUser(userdetail);

				// ✅ 2. Set localStorage

				localStorage.setItem(
					"NCD_loggedinUserdetails",
					JSON.stringify(userdetail),
				);
				localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
				localStorage.setItem(
					"NCD_PERMISSIONS",
					JSON.stringify(response.data.permission),
				);

				localStorage.setItem("ncd_username", data.username);
				localStorage.setItem("portal_main_user_id", data.username);
				localStorage.setItem("currentLoggedInProgramId", 1);

				await mapUsername(1, data.username);

				// Check if first time user
				const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
				navigate(hasSeenMapping ? "/dashboard" : "/setting");
			} else {
				toast.error(response.data.message || "Invalid credentials");
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Login failed");

			// toast.error("NCD Server is not responding. Please try again later.");
		} finally {
			setIsLoading(false);
		}
	};

	const verifySickleCaptcha = async (mobile, captcha) => {
		try {
			const response = await axios.post("/nodeapi/scd/sickle-verify-captcha", {
				mobileNumber: mobile,
				captcha: captcha,
			});
			return response.data;
		} catch (error) {
			// if (error.response?.data?.error) {
			//     toast.error(error.response.data.error, {
			//         className: "custom-toast-error"
			//     });
			// }

			toast.error("Sickle server is not responding. Please try again later.", {
				className: "custom-toast-error",
			});

			return null;
		}
	};

	const handleSickleAuth = async () => {
		if (!mobileNumber) return;

		setIsLoading(true);

		try {
			const captchaResponse = await sendCaptcha(mobileNumber);
			if (!captchaResponse?.success) {
				toast.error(
					captchaResponse?.message || "Something went wrong",
					{ className: "custom-toast-error" }
				);
				return;
			}

			// ✅ success case
			const responseData = captchaResponse?.data;

			if (responseData?.value) {
				const verifyCaptchaResponse = await verifySickleCaptcha(
					mobileNumber,
					responseData.value
				);

				if (verifyCaptchaResponse?.success) {
					setShowSendOtp(true);
					setResendTimer(60);

					toast.success(
						verifyCaptchaResponse.message || "OTP sent successfully",
						{ className: "custom-toast-success" }
					);
				} else {
					setShowSendOtp(true);

					toast.error(
						verifyCaptchaResponse?.message || "Captcha not matched",
						{ className: "custom-toast-error" }
					);
				}

			} else {
				toast.error("Captcha value missing!", {
					className: "custom-toast-error",
				});
			}

		} catch (error) {
			console.error("Error:", error);

			toast.error(
				error?.response?.data?.message ||
				error?.message ||
				"Server not responding",
				{ className: "custom-toast-error" }
			);

		} finally {
			setIsLoading(false);
		}
	};

	const verifySickleOtp = async () => {
		try {
			setIsLoading(true);

			const response = await axios.post("/nodeapi/scd/sickle-verify-otp", {
				mobileNumber: mobileNumber,
				otp: SickleOtpText,
			});

			if (response.data.success === true) {
				const responseData = response.data.data;

				// ✅ tokens (no more result)
				localStorage.setItem("sickle_token", responseData.token);
				localStorage.setItem("sickle_refresh_token", responseData.refresh_token);
				const facilityDetails = await sickleAPI.getFacility({ stateId: responseData.state_id, districtId: responseData.district_id, facilityId: responseData.facility_id });
				if (facilityDetails.success) {
					const facilityInfo = facilityDetails?.data?.result[0] || {};
					// ✅ user details
					const userdetail = {
						firstname: responseData.fname,
						rolename: responseData.role_id == 5 ? "Health Facility User" : "",
						facilitydetail: facilityInfo.facility_name || "",
						username: responseData.mobileNumber,
						stateCode: responseData.state_id,
						districtCode: responseData.district_id,
						block_lgd_code: facilityInfo.block_lgd_code || null,
						taluka_lgd_code: facilityInfo.taluka_lgd_code || null,
						facilityId: responseData.facility_id,
						InchargeMobile: mobileNumber,
						permissions: responseData.permissions || [], // ✅ added permissions
						location_type: facilityInfo.location_type, // ✅ added location type
						health_facility_type: facilityInfo.health_facility_type, // ✅ added health facility type
					};

					localStorage.setItem(
						"SICKLE_loggedinUserdetails",
						JSON.stringify(userdetail)
					);

					localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
					localStorage.setItem("sickle_username", mobileNumber);
					localStorage.setItem("portal_main_user_id", mobileNumber);
					localStorage.setItem("currentLoggedInProgramId", 2);

					await mapUsername(2, mobileNumber);

					// ✅ navigation logic
					const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
					navigate(hasSeenMapping ? "/dashboard" : "/setting");
				} else {
					toast.error("Failed to fetch facility details. Please try again.", {
						className: "custom-toast-error",
					});
				}
			} else {
				toast.error(response.data.message || "Invalid OTP", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error(
				error?.response?.data?.message || "Error verifying OTP",
				{
					className: "custom-toast-error",
				}
			);
		} finally {
			setIsLoading(false);
		}
	};

	const loginPMNDP = async () => {
		try {
			setIsLoading(true);

			const encryptedEmail = encryptData(email);
			const encryptedPassword = encryptData(password);

			const response = await axios.post(
				"/nodeapi/pmndp/pmndp-login",
				{
					username: encryptedEmail,
					password: encryptedPassword,
				},
				{
					headers: {
						"Content-Type": "application/json",
						"x-encrypted": "true",
					},
				},
			);

			if (response.data.success) {
				const responseData = response.data.data;

				localStorage.setItem("PMNDP_token", responseData.token);

				const userdetail = {
					firstname: responseData.user?.name,
					rolename: "",
					roleId: responseData.user?.role_id,
					facilitydetail: "",
					username: responseData.user?.email,
					id: responseData.user?.id,
					stateCode: responseData.user?.state_id,
					district_id: responseData.user?.district_id,
					facilityTypeId: responseData.user?.facility_id,
					InchargeMobile: responseData.user?.mobile,
				};

				localStorage.setItem(
					"PMNDP_loggedinUserdetails",
					JSON.stringify(userdetail),
				);
				localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
				localStorage.setItem("pmndp_username", responseData.user?.email);

				// Check if first time user
				const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
				navigate(hasSeenMapping ? "/dashboard" : "/setting");
			} else {
				toast.error(response.data.msg || "Invalid Email or Password", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error("Username Or Password Incorrect", {
				className: "custom-toast-error",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const loginNikshay = async () => {
		try {
			setIsLoading(true);

			const encryptedEmail = encryptData(email);
			const encryptedPassword = encryptData(password);

			const response = await axios.post(
				"/nodeapi/nikshay/sso-login",
				{
					username: encryptedEmail,
					password: encryptedPassword,
				},
				{
					headers: {
						"Content-Type": "application/json",
						"x-encrypted": "true",
					},
				},
			);

			if (response.data.success) {
				const responseData = response.data.data;

				localStorage.setItem("NIKSHAY_valid_user", responseData.user.active);

				const userdetail = {
					active: responseData.user.active,
					canDeletePatients: responseData.user.canDeletePatients,
					clientId: responseData.user.clientId,
					createdAt: responseData.user.createdAt,
					description: responseData.user.description,
					hierarchyId: responseData.user.hierarchyId,
					id: responseData.user.id,
					restrictedView: responseData.user.restrictedView,
					selectiveHierarchyMapping:
						responseData.user.selectiveHierarchyMapping,
					ssoId: responseData.user.ssoId,
					staffId: responseData.user.staffId,
					updatedAt: responseData.user.updatedAt,
					username: responseData.user.username,
					viewOnly: responseData.user.viewOnly,
					visible: responseData.user.visible,
				};

				localStorage.setItem(
					"NIKSHAY_loggedinUserdetails",
					JSON.stringify(userdetail),
				);

				localStorage.setItem("portal_main_user_id", responseData.user.username);

				localStorage.setItem("currentLoggedInProgramId", 4);

				localStorage.setItem(
					"NIKSHAY_Permissions",
					JSON.stringify(responseData?.permissions),
				);

				await mapUsername(4, responseData.user.username);

				// Check if first time user
				const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
				navigate(hasSeenMapping ? "/dashboard" : "/setting");
			} else {
				toast.error(response.data.msg || "Invalid username or Password", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error("Username Or Password Incorrect", {
				className: "custom-toast-error",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const encryptText = async (plaintext) => {
		try {
			const resEncrypt = await axios.post(
				"nodeapi/uwin/encryption",
				{
					plaintext: plaintext,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			);
			return resEncrypt.data.data.encrypted;
		} catch (error) { }
	};

	const loginUwin = async () => {
		try {
			setIsLoading(true);

			const response = await axios.post(
				"nodeapi/uwin/user-login",
				{
					mobile_number: await encryptText(email),
					password: await encryptText(password),
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			);
			if (response.data.success) {
				toast.success(
					response.data.message || "OTP Sent on your registered mobile number",
					{
						className: "custom-toast-success",
					},
				);
				setUwinTxnId(response.data.data.txnId);
				setShowSendOtp(true);
				setResendTimer(60);
			} else {
				toast.error(response.data.message || "Invalid Username or Password", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error(
				error?.response?.data?.message || "Invalid Username or Password",
				{ className: "custom-toast-error" },
			);
		} finally {
			setIsLoading(false);
		}
	};

	const verifyUwinOtp = async () => {
		try {
			setIsLoading(true);
			const response = await axios.post("nodeapi/uwin/user-verify-otp", {
				txnId: uwinTxnId,
				otp: await encryptText(UwinOtpText),
				mobile_number: email,
			});

			if (response.data.success) {
				localStorage.setItem(
					"uwin_token",
					response.data.data.response.accessToken,
				);
				localStorage.setItem(
					"uwin_refresh_token",
					response.data.data.response.refreshToken,
				);

				const userResponse = await uwinAPI.getUserDetails();

				if (userResponse.success) {
					if (userResponse.data[0] || userResponse.data[0] > 0) {
						const userDetails = userResponse.data[0];
						if (
							(userDetails.role_name != "Vaccinator" &&
								userDetails.role_name != "Delivery Point Manager" &&
								userDetails.role_name != "Health Facility Manager" &&
								userDetails.role_name != "Both(Vaccinator & Delivery Manager)" &&
								userDetails.role_name != "ASHA") ||
							userDetails.facility_name == null
						) {
							toast.error("User is not authorized to perform this activity", {
								className: "custom-toast-error",
							});
							setTimeout(() => {
								window.location.reload();
							}, 3000);
							return;
						}
						const userdetail = {
							firstname: userDetails.display_name,
							rolename: userDetails.role_name,
							facilitydetail:
								userDetails.facility_name +
								", " +
								userDetails.subdistrict_name +
								", " +
								userDetails.district_name +
								", " +
								userDetails.state_name,
							username: userDetails.mobile_number,
							stateCode: userDetails.state_code,
							districtCode: userDetails.district_code,
							facilityTypeId: userDetails.facility_id,
							InchargeMobile: email,
							user_id: userDetails.user_id,
						};

						localStorage.setItem(
							"uwin_loggedinUserdetails",
							JSON.stringify(userdetail),
						);
						localStorage.setItem(
							"loggedinUserdetails",
							JSON.stringify(userdetail),
						);
						localStorage.setItem("uwin_username", email);
						localStorage.setItem(
							"UWIN_Permissions",
							JSON.stringify(response.data?.data?.permissions),
						);

						localStorage.setItem(
							"portal_main_user_id",
							userDetails.mobile_number,
						);

						localStorage.setItem("currentLoggedInProgramId", 6);

						await mapUsername(6, userDetails.mobile_number);

						// Check if first time user
						const hasSeenMapping = localStorage.getItem(
							"hasSeenProgramMapping",
						);
						if (userdetail.rolename === "Health Facility Manager") {
							navigate("/uip-vaccination-center");
						} else {
							navigate(hasSeenMapping ? "/dashboard" : "/setting");
						}
					} else {
						toast.error("No facility details found for this user", {
							className: "custom-toast-error",
						});
					}
				} else {
					toast.error(userResponse.message || "Failed to fetch user details", {
						className: "custom-toast-error",
					});
				}
			} else {
				toast.error(response.data.message || "Invalid OTP", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			let errorMessage = "Error verifying OTP";

			try {
				const responseMessage = error?.response?.data?.message;

				if (responseMessage) {
					const parsedMessage = JSON.parse(responseMessage);

					errorMessage =
						parsedMessage?.loginBody?.error || responseMessage;
				}
			} catch (e) {
				errorMessage =
					error?.response?.data?.message || errorMessage;
			}

			toast.error(errorMessage, {
				className: "custom-toast-error",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const loginJanani = async () => {
		try {
			setIsLoading(true);

			const response = await rchAPI.login({
				userName: email,
				password: password,
			});

			if (response?.success) {
				const data = response?.data?.data[0];

				if (data?.auth_status === "ALREADY_SESSION_EXISTS") {
					toast.error("You are already logged in on another device using this JANANI ID. Please log out from that device before logging in here.", {
						className: "custom-toast-error",
					});
					return;
				}

				if (data?.auth_status === "SUCCESS") {
					const refreshToken = data?.auth_iam_status?.refresh_token;
					const accessToken = data?.auth_iam_status?.access_token;
					localStorage.setItem("JANANI_refreshToken", refreshToken);
					localStorage.setItem("JANANI_token", accessToken);

					const userdetail = {
						firstname: data?.user_data[0]?.mob,
						rolename: data?.userdesignation_name,
						facilityName: data?.user_data[0]?.facility_name,
						username: data?.user_data[0]?.mob,
						loginuser: data?.user_data[0]?.mob,
						stateCode: data?.user_data[0]?.state_code,
						facilityId: data?.user_data[0]?.facility_id,
						facilityType: data?.user_data[0]?.facility_type_name,
						userId: data?.user_id,
						mobile: data?.user_data[0]?.mob,
					};

					localStorage.setItem(
						"JANANI_loggedinUserdetails",
						JSON.stringify(userdetail),
					);
					localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
					localStorage.setItem("janani_username", data?.user_data[0]?.mob);
					localStorage.setItem("portal_main_user_id", data?.user_data[0]?.mob);
					localStorage.setItem("user_map_id", data?.user_data[0]?.mob);
					localStorage.setItem("currentLoggedInProgramId", 5);

					await mapUsername(5, data?.user_data[0]?.mob);

					// Check if first time user
					// const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
					// navigate(hasSeenMapping ? "/dashboard" : "/setting");

					// Temporary fix: Move directly to dashboard for JANANI
					navigate("/dashboard");
				} else {
					toast.error(response.message || "Login failed", {
						className: "custom-toast-error",
					});
				}
			} else {
				toast.error(response.message || "Invalid credentials", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Login failed", {
				className: "custom-toast-error",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const loginRBSK = async () => {
		try {
			setIsLoading(true);

			const response = await rbskAPI.login({
				userName: email,
				password: password,
				salt: "d3b07384d113edec",
			});

			if (response?.success) {
				const responseData = response?.data;

				if (responseData?.succecced) {
					const token = responseData?.data?.token;
					const user = responseData?.data?.user;
					const username = user?.login_Name || email;

					localStorage.setItem("RBSK_token", token);

					const userdetail = {
						firstname: user?.userName || user?.login_Name,
						rolename: user?.role_Name,
						facilityName: user?.state_Name || "",
						username: username,
						loginuser: username,
						stateCode: user?.state_ID,
						districtCode: user?.district_ID,
						userId: user?.id || user?.userID,
						mobile: user?.mobileNo,
					};

					localStorage.setItem(
						"RBSK_loggedinUserdetails",
						JSON.stringify(userdetail),
					);
					localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
					localStorage.setItem("rbsk_username", username);
					localStorage.setItem("portal_main_user_id", username);
					localStorage.setItem("user_map_id", username);
					localStorage.setItem("currentLoggedInProgramId", 11);

					await mapUsername(11, username);

					const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
					navigate(hasSeenMapping ? "/dashboard" : "/setting");
				} else {
					toast.error(responseData?.message || "Login failed", {
						className: "custom-toast-error",
					});
				}
			} else {
				toast.error(response?.message || "Invalid credentials", {
					className: "custom-toast-error",
				});
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Login failed", {
				className: "custom-toast-error",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const loginEOPD = async () => {
		try {
			setIsLoading(true);

			const res = await eopdAPI.login({
				username: email,
				password: password,
			});
			if (res?.success) {
				const responseData = res?.response;
				const user = responseData;

				const token = user?.token;
				if (token) {
					localStorage.setItem("e-OPD_token", token);
					if (user?.refresh_token) {
						localStorage.setItem("e-OPD_refresh_token", user.refresh_token);
					}

					const userdetail = {
						firstname: user?.name || user?.firstname || user?.role_name || user?.username || email,
						rolename: user?.role_name || "",
						facilityName: user?.facility_name || "",
						facilitydetail: user?.facility_name ? `${user.facility_name}${user.district ? ', ' + user.district : ''}` : "",
						username: user?.username || email,
						stateCode: user?.state_lgd || user?.state || "",
						districtCode: user?.district_lgd || user?.district || "",
						facilityTypeId: user?.facility_type || "",
						userId: user?.nin_id || user?.memberID || user?.username || "",
						mobile: user?.username || "",
						nin_id: user?.nin_id || "",
						hfr_id: user?.hfr_id || "",
						hpr_id: user?.hpr_id || "",
						pmjay_id: user?.pmjay_id || "",
						facility_type: user?.facility_type || "",
						facility_name: user?.facility_name || "",
						memberID: user?.memberID || "",
						name: user?.name || "",
						role: user?.role || "",
						role_name: user?.role_name || "",
						district: user?.district || "",
						state: user?.state || "",
						district_lgd: user?.district_lgd || "",
						state_lgd: user?.state_lgd || "",
						refresh_token: user?.refresh_token || "",
					};

					localStorage.setItem(
						"e-OPD_loggedinUserdetails",
						JSON.stringify(userdetail),
					);
					localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
					localStorage.setItem("e-OPD_username", user?.username || email);
					localStorage.setItem("portal_main_user_id", user?.username || email);
					localStorage.setItem("user_map_id", user?.username || email);
					localStorage.setItem("currentLoggedInProgramId", 12);

					await mapUsername(12, user?.username || email);

					// Check if first time user
					const hasSeenMapping = localStorage.getItem("hasSeenProgramMapping");
					navigate(hasSeenMapping ? "/dashboard" : "/setting");
				} else {
					toast.error(res?.message || "Invalid response format from e-OPD server");
				}
			} else {
				toast.error(res?.message || "Invalid credentials");
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Login failed");
		} finally {
			setIsLoading(false);
		}
	};

	const mapUsername = async (programName, userId) => {
		try {
			setIsPageLoading(true);

			const response = await axios.post("/nodeapi/program-mapping/map", {
				program_id: programName,
				user_id: userId,
			});

			if (response.data.success) {
				if (response.data.existingMapping) {
					setReplaceMappingData({
						program: programName,
						existingUser: response.data.existingUser,
					});
					setShowReplaceModal(true);
				} else {
					//await getActivePrograms();
				}
			}
			setIsPageLoading(false);
		} catch (error) {
			console.error("Error in mapping username:", error);
			setIsPageLoading(false);
			throw error;
		}
	};

	const generateMathCaptcha = () => {
		const num1 = Math.floor(Math.random() * 9) + 1;
		const num2 = Math.floor(Math.random() * 9) + 1;
		const operators = ["+", "-"];
		const operator = operators[Math.floor(Math.random() * operators.length)];

		let answer;
		if (operator === "+") {
			answer = num1 + num2;
		} else {
			answer = num1 - num2;
			if (answer < 0) {
				answer = num2 - num1;
				setMathCaptcha({ question: `${num2} ${operator} ${num1}`, answer });
				return;
			}
		}

		setMathCaptcha({ question: `${num1} ${operator} ${num2}`, answer });
	};

	const handleLogin = async (event) => {
		event.preventDefault();
		setIsLoading(true);

		if (!selectedProgram) {
			toast.error("Please select a program before login.", {
				className: "custom-toast-error",
			});
			setIsLoading(false);
			return;
		}

		// Handle SCD two-step process
		if (selectedProgram === "SCD") {
			if (!ShowSendOtp) {
				// Step 1: Send OTP
				if (!mobileNumber.trim() || mobileNumber.length !== 10) {
					toast.error("Please enter a valid 10-digit mobile number", {
						className: "custom-toast-error",
					});
					setIsLoading(false);
					return;
				}
				await handleSickleAuth();
				return;
			} else {
				// Step 2: Verify OTP
				if (!SickleOtpText.trim() || SickleOtpText.length !== 6) {
					toast.error("Please enter complete 6-digit OTP", {
						className: "custom-toast-error",
					});
					setIsLoading(false);
					return;
				}
				await verifySickleOtp();
				return;
			}
		}

		// Handle programs with captcha
		if (
			selectedProgram === "NCD" ||
			selectedProgram === "PMNDP" ||
			selectedProgram === "Nikshay" ||
			selectedProgram === "UWIN" ||
			selectedProgram === "JANANI" ||
			selectedProgram === "RBSK" ||
			selectedProgram === "e-OPD"
		) {
			if (!email.trim() || !password.trim() || !captcha.trim()) {
				toast.error("Please fill all required fields", {
					className: "custom-toast-error",
				});
				setIsLoading(false);
				return;
			}
			if (parseInt(captcha) !== mathCaptcha.answer) {
				toast.error("Invalid captcha. Try again.", {
					className: "custom-toast-error",
				});
				generateMathCaptcha();
				setCaptcha("");
				setIsLoading(false);
				return;
			}

			if (selectedProgram === "NCD") {
				await loginNCD();
			} else if (selectedProgram === "PMNDP") {
				await loginPMNDP();
			} else if (selectedProgram === "Nikshay") {
				await loginNikshay();
			} else if (selectedProgram === "UWIN") {
				if (!ShowSendOtp) {
					// Step 1: Send OTP
					if (!email.trim() || email.length !== 10) {
						toast.error("Please enter a valid 10-digit mobile number", {
							className: "custom-toast-error",
						});
						setIsLoading(false);
						return;
					}
					await loginUwin();
				} else {
					// Step 2: Verify OTP
					if (!UwinOtpText.trim() || UwinOtpText.length !== 6) {
						toast.error("Please enter complete 6-digit OTP", {
							className: "custom-toast-error",
						});
						setIsLoading(false);
						return;
					}
					await verifyUwinOtp();
				}
			} else if (selectedProgram === "JANANI") {
				await loginJanani();
			} else if (selectedProgram === "RBSK") {
				await loginRBSK();
			} else if (selectedProgram === "e-OPD") {
				await loginEOPD();
			}
			return;
		}

		// Handle other programs without captcha
		if (!email.trim() || !password.trim()) {
			toast.error("Please fill all required fields", {
				className: "custom-toast-error",
			});
			setIsLoading(false);
			return;
		}
	};

	const getButtonLabel = () => {
		if (selectedProgram === "SCD" && !ShowSendOtp) return "GET OTP";
		if (
			(selectedProgram === "SCD" || selectedProgram === "UWIN") &&
			ShowSendOtp
		)
			return "VERIFY OTP";
		return "Login";
	};
	return (
		<>
			{(isPageLoading || isLoading) && <Loader />}
			<AnimateedBackground />
			<section className="background">
				<Container
					className={`main-content z-indexeff d-flex align-items-center justify-content-center main-cont ${selectedProgram ? "expanded" : ""}`}
				>
					<div className="row w-100 bg-white">
						{/* <div className="col-12 text-center logo_main">
                            <img
                                src={"/images/NHM.png"}
                                alt=""
                                className="nhmlogo"
                                onClick={() => navigate('/')}

                            />
                            <img src={"/images/mohfw.svg"} alt="" className="mohfwlogo" />
                        </div> */}
						<div className="col-md-6 d-flex justify-content-center align-items-center Login-res">
							<Form className="w-100 Login-res">
								{!selectedProgram && (
									<>
										{/* <Parichay />
                                        <div className="orstyle">or</div> */}

										<div className="d-flex align-items-center justify-content-center logo_margin">
											<img
												src={"/images/Nhmsvglogo.svg"}
												alt=""
												className="nhmlogo"
												onClick={() => navigate("/")}
											/>
											<img
												src={"/images/emblem.svg"}
												alt=""
												className="mohfwlogo"
											/>
										</div>
									</>
								)}
								<ProgramSelect
									selectedProgram={selectedProgram}
									activePrograms={activePrograms}
									handleProgramChange={handleProgramChange}
									disabled={isReferralLocked}
								/>
								{/* Login Form Fields */}
								{selectedProgram && selectedProgram !== "SCD" && (
									<>
										<Form.Group className="form-group new-form">
											<Form.Control
												type="text"
												placeholder="Enter Username"
												value={email}
												onChange={(e) => setEmail(e.target.value)}
												className="new_padding"
											/>
										</Form.Group>
										<Form.Group className="form-group">
											<div style={{ position: "relative" }}>
												<Form.Control
													type={passwordForm ? "text" : "password"}
													placeholder="Enter Password"
													value={password}
													onChange={(e) => setPassword(e.target.value)}
													className="new_padding"
													style={{ paddingRight: "45px" }} // Add padding for icon space
												/>
												<IconButton
													onClick={() => setPasswordForm((prev) => !prev)}
													style={{
														position: "absolute",
														right: "8px",
														top: "50%",
														transform: "translateY(-50%)",
														padding: "4px",
														color: "#666",
													}}
													edge="end"
													size="small"
													aria-label={
														passwordForm ? "Hide password" : "Show password"
													}
													tabIndex={-1}
												>
													{passwordForm ? (
														<Visibility fontSize="small" />
													) : (
														<VisibilityOff fontSize="small" />
													)}
												</IconButton>
											</div>
										</Form.Group>
									</>
								)}

								{["PMNDP", "Nikshay", "UWIN", "NCD", "JANANI", "RBSK", "e-OPD"].includes(
									selectedProgram,
								) && (
										<CaptchaBox
											mathCaptcha={mathCaptcha}
											captcha={captcha}
											setCaptcha={setCaptcha}
											generateMathCaptcha={generateMathCaptcha}
										/>
									)}

								{selectedProgram === "UWIN" && (
									<>
										{ShowSendOtp && (
											<div
												style={{
													display: "flex",
													gap: "13px",
													marginTop: "20px",
													justifyContent: "center",
												}}
											>
												{uwinOtp.map((value, index) => (
													<input
														key={index}
														id={`otp-input-${index}`}
														type="text"
														maxLength="1"
														value={value}
														onChange={(e) => {
															if (!/^\d*$/.test(e.target.value)) return;
															const newOtp = [...uwinOtp];
															newOtp[index] = e.target.value;
															setUwinOtp(newOtp);
															setUwinOtpText(newOtp.join(""));
															if (e.target.value && index < 5) {
																document
																	.getElementById(`otp-input-${index + 1}`)
																	?.focus();
															}
														}}
														onKeyDown={(e) => {
															if (
																e.key === "Backspace" &&
																!sickleOtp[index] &&
																index > 0
															) {
																document
																	.getElementById(`otp-input-${index - 1}`)
																	?.focus();
															}
														}}
														className="form-control"
														style={{
															width: "40px",
															height: "40px",
															textAlign: "center",
															fontSize: "18px",
														}}
													/>
												))}
											</div>
										)}
									</>
								)}

								{selectedProgram === "SCD" && (
									<>
										<Form.Group className="form-group">
											<Form.Label>Mobile Number</Form.Label>
											<Form.Control
												type="text"
												maxLength="10"
												value={mobileNumber}
												onChange={(e) => {
													const numericValue = e.target.value.replace(
														/\D/g,
														"",
													);
													setMobileNumber(numericValue);
												}}
												placeholder="Enter Mobile Number"
											/>
											{ShowSendOtp && resendTimer > 0 && (
												<small style={{ color: "#999", marginTop: "5px" }}>
													Resend OTP in {resendTimer}s
												</small>
											)}
										</Form.Group>
										{ShowSendOtp && (
											<div
												style={{
													display: "flex",
													gap: "13px",
													marginTop: "20px",
													justifyContent: "center",
												}}
											>
												{sickleOtp.map((value, index) => (
													<input
														key={index}
														id={`otp-input-${index}`}
														type="text"
														maxLength="1"
														value={value}
														onChange={(e) => {
															if (!/^\d*$/.test(e.target.value)) return;
															const newOtp = [...sickleOtp];
															newOtp[index] = e.target.value;
															setSickleOtp(newOtp);
															setSickleOtpText(newOtp.join(""));
															if (e.target.value && index < 5) {
																document
																	.getElementById(`otp-input-${index + 1}`)
																	?.focus();
															}
														}}
														onKeyDown={(e) => {
															if (
																e.key === "Backspace" &&
																!sickleOtp[index] &&
																index > 0
															) {
																document
																	.getElementById(`otp-input-${index - 1}`)
																	?.focus();
															}
														}}
														className="form-control"
														style={{
															width: "40px",
															height: "40px",
															textAlign: "center",
															fontSize: "18px",
														}}
													/>
												))}
											</div>
										)}
									</>
								)}

								<Button
									type="submit"
									className="loginbtnte"
									onClick={handleLogin}
									disabled={isLoading || selectedProgram === "FBNC" || selectedProgram === "AFHC"}
									onMouseOver={(e) => {
										if (!isLoading) {
											e.target.style.backgroundColor = "transparent";
											e.target.style.color = "#007bff";
											e.target.style.border = "2px solid #007bff";
											e.target.style.transition = "all 0.3s ease";
										}
									}}
									onMouseOut={(e) => {
										if (!isLoading) {
											e.target.style.backgroundColor = "";
											e.target.style.color = "";
											e.target.style.border = "";
										}
									}}
								>
									{getButtonLabel()}
								</Button>
							</Form>
						</div>
						<div className="col-md-6 d-flex align-items-center justify-content-center">
							<div
								className={`background_image ${selectedProgram ? "with-form" : ""}`}
							>
								<div className="Master-icons">
									<h3>Swasth Bharat</h3>
									<div className="first-icons">
										{activePrograms?.length > 0 &&
											activePrograms.map((prog, index) => {
												const imgSrc = programLogos[prog.program_id];
												if (!imgSrc) return null;
												return (
													<img key={index} src={imgSrc} alt="Program Logo" />
												);
											})}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Container>
				<Footer />
			</section>
		</>
	);
};
